import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
import axios from 'axios';

import CustomToaster from './CustomToaster';

const styles = theme => ({});

class CustomAddButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            savedList: {},
            alertType: "",
            headContent: "",
            custNum: false,
            isSetToaster: false,
            jwt: this.props.jwt,
            data: this.props.data,
            cart_prods: this.props.cart_prods,
            api_origin: this.props.api_origin,
            api_url: this.props.api_url,
            client_country_id: this.props.client_country_id,
            cantidad: this.props.cart_prods && this.props.cart_prods[this.props.data.id.raw]?this.props.cart_prods[this.props.data.id.raw]:0,
            previusCantidad: this.props.cart_prods && this.props.cart_prods[this.props.data.id.raw]?this.props.cart_prods[this.props.data.id.raw]:0
            
        };

        this.quantityChange = this.quantityChange.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);
        this.removeProductFromCart = this.removeProductFromCart.bind(this);
        this.commmonCartProdUpdate = this.commmonCartProdUpdate.bind(this);
        this.increaseSingleQuantity = this.increaseSingleQuantity.bind(this);
        this.onEnterPressIncreaseQuantity = this.onEnterPressIncreaseQuantity.bind(this);
        if (typeof window !== 'undefined') {
            window.addEventListener("updateReactCart", this.handleResetQuantity.bind(this));
        }
        
    }

    

    handleResetQuantity(e) {
        if(e.detail.product_id==this.state.data.id.raw){
            
            var quantity = e.detail.quantity;
            //const array = [...this.state.cart_prods];
            /*const index = array.indexOf(this.state.data.id.raw);
            if (index > -1) { // only splice array when item is found
                array.splice(index, 1); // 2nd parameter means remove one item only
            }
            this.setState({cart_prods:array});*/
            if(this.state.cart_prods && this.state.cart_prods[this.state.data.id.raw]) {
                if(quantity==0) {
                    delete this.state.cart_prods[this.state.data.id.raw];
                    this.setState({ previusCantidad: this.state.cantidad, cantidad: 0 });
                    this.props.removeIdFromArr(this.state.data.id.raw);
                }
                else{
                    this.state.cart_prods[this.state.data.id.raw]=quantity;
                    this.setState({ previusCantidad: this.state.cantidad, cantidad: quantity });
                }
            }
            
        }
    }
   /* componentDidMount() {
        if (this.props.onCartUpdate) 
            window.addEventListener("updateReactCart", this.handleResetQuantity);
    }*/
    
    componentWillUnmount() {
        if (typeof window !== 'undefined'){        
            window.removeEventListener("updateReactCart", this.handleResetQuantity);
        }
    }
  
      
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({
                data: this.props.data
            });
        }

        if (this.props.cart_prods !== prevProps.cart_prods) {
            this.setState({
                cart_prods: this.props.cart_prods,
                cantidad: this.props.cart_prods[this.props.data.id.raw]
            });
        }
    }

    quantityChange = (e) => {
        
        this.setState({ previusCantidad:this.state.cantidad, cantidad: e.target.value });
    }

    increaseSingleQuantity = async(e) => {

        this.setState({alertType: "add"});
        this.setState({headContent: "Product quantity increase"});
        
        let added_quantity = 1;
        const new_qnty = parseInt(this.state.cantidad) + parseInt(added_quantity);

        this.setState({ cantidad: new_qnty });
        this.setState({ custNum: true });
        
        let stat=null;
        try {
            stat = await WebuserCartApi.update({product_id:this.state.data.id.raw, quantity:new_qnty}, added_quantity);  
        } catch (error) {        
        }

        if (stat) {

            var event = new CustomEvent('updatePHPCart', {
                detail: {
                    product_id: this.state.data.id.raw,
                    product: this.state.data
                }
            });
            
            window.dispatchEvent(event);

            return true;
        }
        if(added_quantity>0) {
            this.props.addIdFromArr(this.state.data.id.raw);
        }
        
    }
    
    onEnterPressIncreaseQuantity = async(e) => {
        if (e.key === 'Enter') {

            let decreasedquantity = parseInt(this.state.cantidad)-parseInt(this.state.previusCantidad);
            const new_qnty = parseInt(this.state.cantidad);
            this.setState({ cantidad: new_qnty });
            this.setState({ custNum: true });

            this.setState({alertType: "add"});
            this.setState({headContent: "Product quantity modified"});
            
            if(new_qnty < 1){
                this.props.removeIdFromArr(this.state.data.id.raw);            
            }
        
            let stat = null;
            try {
                stat = await WebuserCartApi.update({product_id:this.state.data.id.raw, quantity:new_qnty}, decreasedquantity);  
            } catch (error) {        
            }

            if (stat) {
                var event = new CustomEvent('updatePHPCart', {
                    detail: {
                        product_id: this.state.data.id.raw,
                        product: this.state.data
                    }
                });
                window.dispatchEvent(event);
                return true;
            }
            if(new_qnty>0) {
                this.props.addIdFromArr(this.state.data.id.raw);
            }
        }
    }

    decreaseQuantity = async(e) => {
        
        let decreasedquantity = 1;
        const new_qnty = parseInt(this.state.cantidad) - parseInt(decreasedquantity);
        this.setState({ cantidad: new_qnty });
        this.setState({ custNum: true });

        this.setState({alertType: "add"});
        this.setState({headContent: "Product quantity decrease"});
        
        if(new_qnty < 1){
            this.props.removeIdFromArr(this.state.data.id.raw);           
        }
      
        let stat = null;
        try {
            stat = await WebuserCartApi.update({product_id:this.state.data.id.raw, quantity:new_qnty}, -parseInt(decreasedquantity));  
        } catch (error) {        
        }

       if (stat) {
            var event = new CustomEvent('updatePHPCart', {
                detail: {
                    product_id: this.state.data.id.raw,
                    product: this.state.data
                }
            });
            window.dispatchEvent(event);
            return true;
        }
        if(new_qnty>0) {
            this.props.addIdFromArr(this.state.data.id.raw);
        }
    }

    commmonCartProdUpdate = async(id, quantity) => {
        
        const data = JSON.stringify({
            "product_id": id,
            "quantity": quantity
        });
        
        let addPrdDetls = await axios.post(this.state.api_url+`/carts`, data,
        {   
            headers: {
                    "Accept": "application/json, text/javascript, */*; q=0.01",
                    "Authorization": this.state.jwt
                }
            }
        );

        if (addPrdDetls) {

            var event = new CustomEvent('updatePHPCart', {
                detail: {
                    product_id: this.state.data.id.raw,
                    product: this.state.data
                }
            });
            
            window.dispatchEvent(event);

            return true;
        }
        if(quantity>0) {
            this.props.addIdFromArr(this.state.data.id.raw);
        }
    }    

    removeProductFromCart = async(e) => {

        this.setState({isSetToaster: false});

        this.setState({alertType: "rmv"});
        this.setState({headContent: "Product removed"});
        
        let removePrdDetls=null;
        try {
            removePrdDetls = await WebuserCartApi.remove(this.state.data.id.raw, parseInt(this.state.cantidad));  
        } catch (error) {
        
        }
        
        /*let removePrdDetls = await axios.delete(this.state.api_url+`/carts/`+this.state.data.id.raw,
        {   
            headers: {
                "Accept": "application/json, text/javascript, * / *; q=0.01",
                "Authorization": this.state.jwt
            }
        });*/
        
        if (removePrdDetls) {            
            this.setState({isSetToaster: true});
            this.props.removeIdFromArr(this.state.data.id.raw);
            var event = new CustomEvent('updatePHPCart', {
                detail: {
                    product_id: this.state.data.id.raw,
                    product: this.state.data
                }
            });
            
            window.dispatchEvent(event);
            
            this.closeToast();
        }
    }

    closeToast =() => {
        setTimeout(() => {
            this.setState({isSetToaster: false});
        }, 3000);
    }

    render() {

        const { data, client_country_id } = this.state;

        return ( 
            <>
                <li className="cardBtnLi">
                    <div className="qtyWrapper secondary"> 
                        <input 
                            type="text" 
                            name="cantidad"
                            value={this.state.cantidad ? this.state.cantidad : 1 }
                            className="qtyWrapperInput prd-in-card" 
                            onChange={(e) => this.quantityChange(e)}
                            onKeyDown={(e) => this.onEnterPressIncreaseQuantity(e)}
                        />
                        <ul className="indUl">
                            <li 
                                className="plusQty prd-in-card cardBtnLi toast-link" 
                                onClick={(e) => this.increaseSingleQuantity(e)}
                                data-toast={`toast-${data.id.raw}`}
                                data-producto={data.id.raw}
                                data-value1={JSON.parse(data.product_data.raw).manufacturer_id}
                                data-value2={client_country_id}
                            >
                                <img className="liImg" src="/img/svgs/plus-icon.svg" alt="plus" />
                            </li>
                            <li 
                                className="minusQty prd-in-card cardBtnLi toast-link" 
                                onClick={(e) => this.decreaseQuantity(e)} 
                                data-toast={`toast-${data.id.raw}`}
                                data-producto={data.id.raw}
                                data-value1={JSON.parse(data.product_data.raw).manufacturer_id}
                                data-value2={client_country_id}
                            >
                                <img className="liImg" src="/img/svgs/minus-icon.svg" alt="minus" />
                            </li>
                        </ul>
                    </div>

                </li>
                <li>
                    <a
                        // id="eliminar ml-auto-del" 
                        className="delete-link prd-in-card toast-link" 
                        onClick={(e) => this.removeProductFromCart(e)} 
                        data-toast={`toast-${data.id.raw}`}
                        data-producto={data.id.raw}
                        data-value1={JSON.parse(data.product_data.raw).manufacturer_id}
                        data-value2={client_country_id}
                    >
                        <img className="liImg" src="/img/svgs/delete-icon.svg" alt="delete-icon" />
                    </a>
                </li>

                {this.state.isSetToaster ? 
                    <CustomToaster
                       data={this.state.data}
                       alertType={this.state.alertType}
                       headContent={this.state.headContent}
                       sId={data.id.raw}
                       listId={false}
                       lang={this.state.lang}
                    /> 
                : ""}
            </>
        );

    }

}

export default withStyles(styles)(withTranslation()(CustomAddButton));